import * as go from 'gojs';
import { TEXT_NODE_TEXT_BLOCK } from './../../common/config/common-part-names';

export const editOnDoubleClick = (e: go.InputEvent, thisObj: go.GraphObject) => {
  if (!thisObj.part || !thisObj.diagram) {
    return;
  }

  const tb = thisObj.part.findObject(TEXT_NODE_TEXT_BLOCK);
  if (!!tb && tb instanceof go.TextBlock) {
    thisObj.diagram.commandHandler.editTextBlock(tb);
  }
};
